import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { CommunicationVariablesContext } from 'gw-capability-fnol-adac-react';
import metadata from './AdacSessionExpired.metadata.json5';
import styles from './AdacSessionExpired.module.scss';

function AdacSessionExpired({ history }) {
    const { communicationVariables } = useContext(CommunicationVariablesContext)
    const { token } = communicationVariables;

    const overrides = {
        logInAgainButton: {
            onClick: () => {
                history.push({
                    pathname: `/login/${token}`,
                });
            },
            visible: token !== null
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };
    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(AdacSessionExpired);
